import { render, staticRenderFns } from "./3M.vue?vue&type=template&id=32471321&scoped=true"
import script from "./3M.vue?vue&type=script&lang=js"
export * from "./3M.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32471321",
  null
  
)

export default component.exports